import { useEffect } from 'react';

import { useRestrictedActionShowActions } from './RestrictedActionShowContext';

import { getRestrictedAction } from './restApi';

const RestrictedActionShowLoader = ({ restrictedAction }) => {
  const { initializeState, onResponse, onError } = useRestrictedActionShowActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    getRestrictedAction({ restrictedAction, onResponse, onError });
  }, []);

  return null;
};

export default RestrictedActionShowLoader;
